/* eslint-disable react/jsx-no-target-blank */
import { AsideFooter } from './aside-footer';
import { AsideTabs } from './aside-tabs';
import styles from './styles.module.scss';
import { TabsBase } from './tabs/tabs-base';
import clsx from 'clsx';
import { InlineSvg } from 'components/svg';
import { useLayout } from 'layouts/core/layout.context';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from 'utils/assets';

const AsideDefault = () => {
  const { config } = useLayout();
  const { classes } = useLayout();
  const [link, setLink] = useState<string>('menu');

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      id="kt_aside"
      className={clsx('aside aside-extended', classes.aside.join(' '), styles.asideContainer)}
      data-kt-drawer="true"
      data-kt-drawer-name="aside"
      data-kt-drawer-activate="{default: true, lg: false}"
      data-kt-drawer-overlay={isMobile ? 'true' : 'false'}
      data-kt-drawer-width="auto"
      data-kt-drawer-direction="start"
      data-kt-drawer-toggle="#kt_aside_toggle"
    >
      {/* begin::Primary */}
      <div className="aside-primary d-flex flex-column align-items-lg-center flex-row-auto">
        {/* begin::Logo */}
        <div
          className="aside-logo d-none d-lg-flex flex-column align-items-center flex-column-auto py-10"
          id="kt_aside_logo"
        >
          <Link to="/dashboard">
            <img src={toAbsoluteUrl('/media/logos/logo.png')} alt="logo" className="h-35px" />
          </Link>
        </div>
        {/* end::Logo */}
        {/* begin::Nav */}
        <div
          className="aside-nav d-flex flex-column align-items-center flex-column-fluid w-100 pt-5 pt-lg-0"
          id="kt_aside_nav"
        >
          <AsideTabs link={link} setLink={setLink} />
        </div>
        {/* end::Nav */}
        <AsideFooter />
      </div>
      {/* end::Primary */}
      {config.aside.secondaryDisplay && (
        <>
          {/* begin::Secondary */}
          <div className="aside-secondary d-flex flex-row-fluid">
            {/* begin::Workspace */}
            <div className="aside-workspace my-5 p-5" id="kt_aside_wordspace">
              <TabsBase link={link} />
            </div>
            {/* end::Workspace */}
          </div>
          {/* end::Secondary */}
          {/* begin::Aside Toggle */}
          <button
            id="kt_aside_toggle"
            className={clsx(
              'btn btn-sm btn-icon bg-body btn-color-gray-700 btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm d-none d-lg-flex',
              classes.asideToggle.join(' ')
            )}
            data-kt-toggle="true"
            data-kt-toggle-state="active"
            data-kt-toggle-target="body"
            data-kt-toggle-name="aside-minimize"
          >
            <InlineSvg path="/media/icons/duotune/arrows/arr063.svg" className="svg-icon-2 rotate-180" />
          </button>
          {/* end::Aside Toggle */}
        </>
      )}
    </div>
  );
};

export { AsideDefault };
